import React from 'react';
import '../style/Footer.css';

const Footer = () => {
    return (
        <footer className="footer">
            <p>
                Created with ❤️ by <a href="https://tomerasraf-portfolio.netlify.app/">Tomer Asraf</a>
            </p>
        </footer>
    );
};

export default Footer;